import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _partition from "lodash/partition";
import _partial from "lodash/partial";
var _displayStringsForMacOs = {
  Alt: '⌥',
  Control: '⌃',
  Meta: '⌘',
  Shift: '⇧'
};
var _displayStrings = {
  Alt: 'Alt',
  Control: 'Ctrl',
  Meta: 'Ctrl',
  Shift: 'Shift',
  ArrowDown: '↓',
  ArrowLeft: '←',
  ArrowRight: '→',
  ArrowUp: '↑'
};

var getPrettyKeyName = function getPrettyKeyName() {
  var isApple = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferredDisplayString = isApple ? _displayStringsForMacOs[keyName] : '';
  return preferredDisplayString || _displayStrings[keyName] || keyName.toUpperCase();
};

var getIsModifierKeyName = function getIsModifierKeyName() {
  var keyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ['Alt', 'AltGraph', 'CapsLock', 'Control', 'Fn', 'FnLock', 'Hyper', 'Meta', 'NumLock', 'ScrollLock', 'Shift', 'Super', 'Symbol', 'SymbolLock'].includes(keyName);
};
/**
 * Return a formatted display string representing a keyboard shortcut for
 * the current platform, with automatic platform-dependent stylization and
 * replacement of `Meta` with either Command or Control.
 *
 * @example
 *
 * ```js
 * getKeyboardShortcutString(['Meta', 'a']); // '⌘A' or 'Ctrl+A'
 * ```
 */


export function getKeyboardShortcutString(keyNames) {
  var isApple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var separator = isApple ? '' : '+';

  var format = function format() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return arr.map(_partial(getPrettyKeyName, isApple));
  };

  var _partition2 = _partition(keyNames, getIsModifierKeyName),
      _partition3 = _slicedToArray(_partition2, 2),
      modifierKeyNames = _partition3[0],
      plainKeyNames = _partition3[1];

  var displayModifiers = format(modifierKeyNames);
  var displayKeys = format(plainKeyNames).sort();
  return modifierKeyNames.length > 0 ? [].concat(_toConsumableArray(displayModifiers), _toConsumableArray(displayKeys)).join(separator) : displayKeys.join(separator);
}